const exceljs = require("exceljs");

exceljs.install = function(Vue) {
  if (!Vue.$exceljs) {
    Vue.$exceljs = exceljs;
    Object.defineProperties(Vue.prototype, {
      $exceljs: {
        get() {
          return exceljs;
        }
      }
    });
  }
};

export default exceljs;
